import React from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import FormItemsContainer from "../../../containers/FormItemsContainer";
import { countHits, handleChangeIds } from "../../../../utils/checkBoxFunc";

type Props = {
  // NOTE: サイドバーと詳細検索モーダルで同時にmountされるため、mountごとにidPrefixを変えてid衝突を防ぐ
  idPrefix: string;
};

function PortalPCAreaCheckboxList({ idPrefix }: Props) {
  const {
    areaIds,
    volOrJob,
    setAreaIds,
    onlineChecked,
    canJoinFarawayChecked,
    aggs,
  } = ArticleSearchContainer.useContainer();
  const { items } = FormItemsContainer.useContainer();
  const onChange = handleChangeIds(areaIds, setAreaIds);

  return (
    <ul className="portalPcCheckList">
      {items.extended_areas[volOrJob].opts.map((opt) => {
        const id = `${idPrefix}-area-${opt.value}`;
        return (
          <li key={opt.value}>
            <label htmlFor={id}>
              <input
                id={id}
                type="checkbox"
                value={opt.value}
                checked={
                  opt.value === "online" ? onlineChecked : canJoinFarawayChecked
                }
                onChange={onChange}
              />
              <span className="portalPcCheckLabel">
                {opt.label}({countHits(aggs.area_count.area.buckets, opt.value)}
                件)
              </span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}

export default PortalPCAreaCheckboxList;
